{
  "login": {
    "errors": {
      "unexpected": "We couldn't continue right now. Please try again.",
      "additionalVerification": "Additional verification required",
      "invalidCredentials": "Invalid code or password",
      "sendCode": "Error sending code"
    },
    "email": {
      "title": "Welcome back!",
      "subtitle": "Enter your email to access the platform",
      "label": "Email",
      "placeholder": "you@email.com",
      "continue": "Continue",
      "forgotPassword": "Forgot your password?"
    },
    "verify": {
      "title": "Security Verification",
      "subtitle": "Choose a method to confirm your identity",
      "password": {
        "title": "Password",
        "description": "Enter your password",
        "submit": "Sign in"
      },
      "emailCode": {
        "title": "Email Code",
        "description": "Get a 6-digit code in your email",
        "send": "Send code to {{email}}",
        "sentTo": "Code sent to <email>{{email}}</email>",
        "submit": "Verify",
        "resendIn": "Resend in {{seconds}}s",
        "sending": "Sending...",
        "resend": "Resend code"
      },
      "sms": {
        "title": "SMS Code",
        "description": "Verification by phone",
        "comingSoon": "Coming soon"
      },
      "back": "Back"
    }
  },
  "forgotPassword": {
    "validation": {
      "invalidEmail": "Invalid email"
    },
    "errors": {
      "send": "Error sending email"
    },
    "success": {
      "title": "Email sent!",
      "description": "If the email exists in our records, you will receive a recovery link."
    },
    "backToLogin": "Back to login",
    "title": "Recover password",
    "subtitle": "Enter your email to receive a recovery link",
    "emailLabel": "Email",
    "emailPlaceholder": "you@email.com",
    "submit": "Send link"
  },
  "resetPassword": {
    "validation": {
      "minLength": "Password must be at least 8 characters",
      "complexity": "Must contain an uppercase letter, a lowercase letter and a number",
      "mismatch": "Passwords do not match"
    },
    "invalid": {
      "title": "Invalid link",
      "description": "The recovery link is invalid or has expired.",
      "requestNew": "Request a new link"
    },
    "success": {
      "title": "Password changed!",
      "description": "Your password has been reset successfully. Log in with your new password.",
      "goToLogin": "Go to login"
    },
    "toast": {
      "success": "Password changed successfully!"
    },
    "errors": {
      "reset": "Error resetting password. The link may have expired."
    },
    "title": "New password",
    "subtitle": "Enter your new password below",
    "passwordLabel": "New password",
    "passwordPlaceholder": "At least 8 characters",
    "confirmLabel": "Confirm password",
    "confirmPlaceholder": "Repeat the password",
    "submitting": "Resetting...",
    "submit": "Reset password",
    "backToLogin": "Back to login"
  },
  "platformRoot": {
    "title": "A members area for those who teach",
    "description": "You have reached Xtreed. If you are a student, sign in through the address your school sent you — each members area has its own.",
    "devShortcuts": "Development shortcuts"
  },
  "deepLink": {
    "errors": {
      "incompleteLink": "The access link is incomplete or malformed. Ask the administrator to generate a new link.",
      "validateFailed": "We could not validate the access link."
    },
    "footer": "Having trouble signing in? <link>Go to the regular login</link>",
    "verifying": {
      "title": "Verifying access",
      "description": "We are validating your secure link. This only takes a moment.",
      "steps": {
        "token": {
          "title": "Validating token",
          "subtitle": "Checking signature and expiration"
        },
        "auth": {
          "title": "Authenticating user",
          "subtitle": "Creating secure session"
        },
        "redirect": {
          "title": "Redirecting",
          "subtitle": "Taking you to the platform"
        }
      },
      "doNotClose": "Do not close this tab during verification"
    },
    "success": {
      "welcome": "Welcome, {{name}}!",
      "granted": "Access granted!",
      "description": "Authentication completed successfully. Taking you to the platform…",
      "redirecting": "Redirecting"
    },
    "error": {
      "title": "Unable to sign in",
      "fallback": "There was a problem validating your access link. Please try again.",
      "reasonsTitle": "Most common reasons",
      "reasons": {
        "used": "The link has already been used (single use)",
        "expired": "The link has expired (valid for 24 hours)",
        "modified": "The link was modified or is incomplete"
      },
      "retry": "Try again",
      "goToLogin": "Go to login"
    }
  },
  "devflixAuthorize": {
    "errors": {
      "incompleteRequest": "The DevFlix request is incomplete. Go back and try again.",
      "authorizeFailed": "We could not authorize DevFlix. Check your access and try again."
    },
    "title": {
      "unauthorized": "Access not authorized",
      "opening": "Opening your DevFlix"
    },
    "confirming": "Securely confirming your account and access…"
  },
  "terms": {
    "toast": {
      "success": "Terms accepted successfully!",
      "error": "Error saving your acceptance of the terms. Please try again."
    },
    "header": "Terms of Use",
    "title": "Terms and Conditions of Use",
    "subtitle": "To keep using the platform, read and accept the terms below.",
    "iframeTitle": "Terms and Conditions",
    "agree": "I have read and agree to the {{name}} <bold>Terms and Conditions of Use</bold>.",
    "auditInfo": "By accepting, your IP address and approximate location will be recorded for audit purposes. Your browser will ask for permission to access your location.",
    "submitting": "Recording acceptance...",
    "submit": "Accept and Continue"
  },
  "magicLink": {
    "validation": {
      "invalidEmail": "Invalid email"
    },
    "errors": {
      "send": "Error sending magic link"
    },
    "sent": {
      "title": "Link Sent!",
      "description": "We sent an access link to <email>{{email}}</email>",
      "nextSteps": "Next steps:",
      "steps": {
        "inbox": "Check your inbox",
        "click": "Click the link you received",
        "auto": "You will be signed in automatically"
      },
      "notReceived": "Didn't get it? Check your spam folder or try again in a few minutes.",
      "backToLogin": "Back to Login"
    },
    "title": "Magic Link",
    "subtitle": "Enter your email and get a secure access link",
    "emailLabel": "Email",
    "emailPlaceholder": "you@email.com",
    "sending": "Sending...",
    "submit": "Send Magic Link",
    "back": "Back"
  },
  "socialButton": {
    "connecting": "Connecting...",
    "continueWith": "Continue with {{provider}}"
  },
  "socialButtons": {
    "divider": {
      "login": "or sign in with",
      "register": "or sign up with"
    },
    "withProvider": {
      "login": "Sign in with {{provider}}",
      "register": "Sign up with {{provider}}"
    },
    "magicLink": "Magic link by email",
    "privacy": {
      "register": "By signing up with social networks, you agree that we may access your basic profile information.",
      "login": "Your data is protected and we do not share it with third parties."
    }
  },
  "social": {
    "errors": {
      "connect": "Error connecting with {{provider}}",
      "login": "Error signing in with {{provider}}"
    },
    "welcomeNew": "Welcome! Your account was created with {{provider}}",
    "loggedIn": "Signed in with {{provider}}"
  },
  "setPassword": {
    "validation": {
      "minLength": "Password must be at least 8 characters",
      "complexity": "Must contain an uppercase letter, a lowercase letter and a number",
      "mismatch": "Passwords do not match"
    },
    "invalid": {
      "title": "Invalid link",
      "description": "The access link is invalid or has already been used.",
      "requestNew": "Request a new link"
    },
    "success": {
      "title": "Password set!",
      "description": "Your password has been set successfully. Log in to get started.",
      "goToLogin": "Go to login"
    },
    "toast": {
      "success": "Password set successfully!"
    },
    "errors": {
      "set": "Error setting the password. The link may have expired."
    },
    "title": "Set your password",
    "subtitle": "Choose a password to access your members area",
    "passwordLabel": "Password",
    "passwordPlaceholder": "At least 8 characters",
    "confirmLabel": "Confirm password",
    "confirmPlaceholder": "Repeat the password",
    "submitting": "Setting...",
    "submit": "Set password",
    "backToLogin": "Back to login"
  }
}
